// src/components/AboutBrowserTabs.js
import React, { useEffect } from 'react';

const AboutBrowserTabs = () => {
  useEffect(() => {
    // Find all browser tabs and instructions
    const browserTabs = document.querySelectorAll('.browser-tab');
    const browserInstructions = document.querySelectorAll('.browser-instructions');

    // Function to switch instructions
    function switchBrowser(browserName) {
      // Hide all instructions
      browserInstructions.forEach(instruction => {
        instruction.style.display = 'none';
      });

      // Show instructions for selected browser
      const selectedInstructions = document.getElementById(`${browserName}-instructions`);
      if (selectedInstructions) {
        selectedInstructions.style.display = 'block';
      }

      // Update active tab
      browserTabs.forEach(tab => {
        if (tab.getAttribute('data-browser') === browserName) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });
    }

    // Add click handlers
    browserTabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const browser = this.getAttribute('data-browser');
        switchBrowser(browser);
      });
    });

    // Initialize with first tab
    const defaultBrowser = browserTabs[0]?.getAttribute('data-browser');
    if (defaultBrowser) {
      switchBrowser(defaultBrowser);
    }

    // Cleanup function
    return () => {
      browserTabs.forEach(tab => {
        tab.removeEventListener('click', function() {
          const browser = this.getAttribute('data-browser');
          switchBrowser(browser);
        });
      });
    };
  }, []);

  return null;
};

export default AboutBrowserTabs;